import { PAYIN_COUNTRY_BY_CODE } from "../constants/payins.constants";
import type { PayinCountry } from "../types/payins.types";

export interface PayinCountryFlagProps {
  country: PayinCountry;
  className?: string;
}

/** Flag image for a payin country, resolved from the module's country catalog. */
export function PayinCountryFlag({ country, className }: PayinCountryFlagProps) {
  const config = PAYIN_COUNTRY_BY_CODE.get(country);
  if (!config) return null;
  return (
    <img
      src={`https://flagcdn.com/${config.iso2}.svg`}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={className ?? "h-3.5 w-5 shrink-0 rounded-[2px] object-cover"}
    />
  );
}
